import { memo } from 'react';
import styles from './AdditionalMessage.module.scss';

type Props = {
  message: string;
};

const AdditionalMessage = ({ message }: Props) => {
  if (!message) {
    return null;
  }

  return (
    <p className={styles.additionalMessage} data-testid="additional-message">
      {message}
    </p>
  );
};

export default memo(AdditionalMessage);
